// extracted by mini-css-extract-plugin
export default {"newsl":"AboutNewsletter_newsl__LJJ3v","content":"AboutNewsletter_content__j3XOl","texts":"AboutNewsletter_texts__za7VI","people":"AboutNewsletter_people__bDW-J"};